// eslint-disable-next-line import/no-anonymous-default-export
export default (url) => {
  const split = url.split("/");

  return split;
};
